import { DropdownField } from '@cian/components';
import * as React from 'react';

import { ERoomsTotal } from '../../../../../../../json_query';

export interface IRoomsTotalProps {
  roomsTotal: ERoomsTotal;
  onRoomsTotalChanged(value: ERoomsTotal): void;
}

export const RoomsTotalComponents: React.StatelessComponent<IRoomsTotalProps> = props => (
  <DropdownField
    value={props.roomsTotal}
    onValueChange={props.onRoomsTotalChanged}
    values={[
      { value: ERoomsTotal.Any, label: 'Неважно' },
      { value: ERoomsTotal.Two, label: '2' },
      { value: ERoomsTotal.Three, label: '3' },
      { value: ERoomsTotal.Four, label: '4' },
      { value: ERoomsTotal.Five, label: '5' },
    ]}
  />
);
